import { render, staticRenderFns } from "./BFStep3Subscription.vue?vue&type=template&id=02581e36"
import script from "./BFStep3Subscription.vue?vue&type=script&lang=js"
export * from "./BFStep3Subscription.vue?vue&type=script&lang=js"
import style0 from "./BFStep3Subscription.vue?vue&type=style&index=0&id=02581e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports